import { Component, OnInit } from "@angular/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../shared";
import { DistCalData } from "./DistCalData";
import { CalendarDayInfo } from "./CalendarDayInfo";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import * as moment from "moment";

@Component({
	selector: "app-district-calendar",
	templateUrl: "./district-calendar.component.html",
	styleUrls: ["./district-calendar.component.css"],
})
export class DistrictCalendarComponent implements OnInit {
	constructor() {}

	ngOnInit() {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	ModeID: number = 2; // Testing //1;
	lstMode: any = [
		{
			ID: 1,
			Desc: "Calendar",
		},
		{
			ID: 2,
			Desc: "Holidays",
		},
	];

	////////////////////////////////////////////
}
